<template>
    <div class="loginForm">
        <a-form
            :form="form"
            v-bind="formItemLayout"
            @submit="handleSubmit"
        >
            <a-form-item label="用户名">
                <a-input
                v-decorator="[
                    'phone',
                    { rules: [{ required: true, message: '请输入手机号' }] },
                ]"
                placeholder="请输入手机号"
                >
                </a-input>
            </a-form-item>
            <a-form-item label="密码">
                <a-input
                    v-decorator="[
                        'userPwd',
                        {rules: [{
                            required: true,
                        
                            validator:(rule, value,callback)=>{
                                let  passwordReg = /^[a-zA-Z](?![a-zA-Z]+$)\w{5,19}$/
                                if (value === '' || value == undefined ) {
                                    callback('密码为6-20位数字、字母或下划线，至少包括其中两种，以字母开头!' );
                                }else if (!passwordReg.test(value)) {
                                    callback('密码为6-20位数字、字母或下划线，至少包括其中两种，以字母开头!' );
                                }else{
                                    callback();
                                }
                            },
                            }],
                        }
                    ]"

                    
                    type="password"
                    placeholder="请输入密码"
                    >
                </a-input>
            </a-form-item>
            <a-form-item
                label="验证码"
                >
                <a-row :gutter="16">
                    <a-col :span="11">
                        <a-input
                        v-decorator="[
                            'yzm',
                            { rules: [{ required: true, message: '请输入验证码' }] },
                        ]"
                        placeholder="请输入验证码"
                        />
                    </a-col>
                    <a-col :span="13">
                        <VerificationCode :IdName="'LoginCanvas'" :isKey="true"  @getimgKey="getimgKey" ></VerificationCode>
                    </a-col>
                </a-row>
            </a-form-item>
            <a-form-item 
                :wrapper-col="{ span: 24, offset: 0 }"
                style="text-align: right"
               >
                <span class="forgotPassword" @click="Jump('/forgotPassword')">
                    忘记密码
                </span>
            </a-form-item>
            <a-form-item
                :wrapper-col="{ span: 24, offset: 0 }"
            >
                <a-button type="primary" html-type="submit" class="btn-primary" style="margin-right: 50px;">
                    登录
                </a-button>
                <a-button  type="primary" class="mainBtn" @click="Jump('/register')">
                        没有账户？
                </a-button>
            </a-form-item>
        </a-form>
    
    </div>
</template>
<script>
    import VerificationCode from '@/components/component/VerificationCode.vue'
    export default {
        components:{
            VerificationCode,
        },
        data() {
            return {
                formItemLayout:{
                    labelCol: { span: 6 },
                    wrapperCol: { span: 18 },
                },
                form: this.$form.createForm(this, {  }),
                imgkey:null,
            };
        },
    
        mounted(){
        },
        methods:{
           
            handleSubmit(e) {
                e.preventDefault();
                this.form.validateFields((err, values) => {
                    if (!err) {
                        let data ={
                            ...values,
                            key:this.imgkey,
                        }
                        this.$emit('handleOk', data)
                    }
                });
            },
            handleReset() {
                this.form.resetFields();
            },
            Jump(e){
                if(e == this.$route.path){
                    
                }else {
                    this.$emit('handlebye')
                    this.$router.push(e)
                }
            },
            getimgKey(key){
                this.imgkey = key
            }
        }
    }
</script>
<style scoped lang="less">
    /deep/.ant-form-explain{
        text-align: left;
    }
    .loginForm{
        width: 400px;
        margin: 20px auto 0;
    }
    .forgotPassword{
        color: @main-color;
        
    }
</style>
